module.exports = __webpack_public_path__ + "static/media/Asset 9@3x.780637cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 9@3x.png
// module id = 2403
// module chunks = 0